import {
    OBTENER_LLAVES,
    GET_CONFIG_FORMINF_HONO,
    GET_ORIGEN_HONORARIOS,
    GET_RESPONSABLES_SOL,
    GET_SITUACIONES_HONO,
    GET_CRITERIOS_FECHA_HONO,
    GET_INFORMES_HONO,
    POST_GENERAR_HONO
} from '../types';


export default function informeHonorariosReducer(state = {}, action) {
    switch (action.type) {
        case OBTENER_LLAVES:
            return { ...state, llaves: action.payload }
        case GET_CONFIG_FORMINF_HONO:
            return { ...state, cfg_formInf: action.payload }
        case GET_ORIGEN_HONORARIOS:
            return { ...state, origenesHonorarios: action.payload }
        case GET_SITUACIONES_HONO:
            return { ...state, situaciones: action.payload }
        case GET_RESPONSABLES_SOL:
            return { ...state, responsables: action.payload }
        case GET_CRITERIOS_FECHA_HONO:
            return { ...state, criteriosFecha: action.payload }
        case GET_INFORMES_HONO:
            return { ...state, listaInformesPrevios: action.payload }
        case POST_GENERAR_HONO:
            return { ...state, respuestaGenerar: action.payload }
        default:
            return state
    }
}